function routeActivityEvents(documents) {
  const events = [];
  const categories = [
    {
      field: 'requests',
      type: 'served',
      outcome: 'aggregate',
      label: 'requests',
      durationField: 'durationMs',
      offsetMinutes: 5
    },
    {
      field: 'renders',
      type: 'refresh',
      outcome: 'aggregate',
      label: 'renders',
      durationField: 'renderDurationMs',
      offsetMinutes: 20
    },
    {
      field: 'validations',
      type: 'validation',
      outcome: 'validated',
      label: 'validations',
      durationField: 'validationDurationMs',
      offsetMinutes: 35
    },
    {
      field: 'renderFailures',
      type: 'refresh',
      outcome: 'failed',
      label: 'failed renders',
      offsetMinutes: 50
    }
  ];

  for (const document of documents) {
    const metrics = typeof document.data === 'function' ? document.data() : document;
    const hour = new Date(`${metrics.hour}:00:00.000Z`);
    if (Number.isNaN(hour.getTime())) continue;

    for (const [index, category] of categories.entries()) {
      const count = metrics[category.field] || 0;
      if (!count) continue;

      events.push({
        id: `${document.id || metrics.hour}:${category.field}`,
        type: category.type,
        outcome: category.outcome,
        activityLabel: category.label,
        activityCount: count,
        occurredAt: hour,
        plotAt: hour.getTime() + category.offsetMinutes * 60 * 1000,
        durationMs: category.durationField
          ? (metrics[category.durationField] || 0) / count
          : 0,
        categoryOrder: index
      });
    }
  }

  return events.sort((left, right) => left.plotAt - right.plotAt);
}

module.exports = { routeActivityEvents };
